export const storageOptions = [
  {
    label: "500 MB",
    value: 500000
  },
  {
    label: "1 GB",
    value: 1000000
  },
  {
    label: "2 GB",
    value: 2000000
  },
  {
    label: "5 GB",
    value: 5000000
  },
  {
    label: "10 GB",
    value: 10000000
  },
  {
    label: "15 GB",
    value: 15000000
  },
  {
    label: "20 GB",
    value: 20000000
  },
  {
    label: "50 GB",
    value: 50000000
  },
  {
    label: "100 GB",
    value: 100000000
  }
];

export const productViews = [
  {
    label: "Simple",
    value: "simple"
  },
  {
    label: "Variant",
    value: "variant"
  }
];

export const smsProviders = [
  {
    label: "BOOM SMS",
    value: "BoomSMS"
  },
  {
    label: "VMG SMS",
    value: "VmgSMS"
  },
  {
    label: "Atom SMS",
    value: "AtomSMS"
  }
];

export const featureOptions = [
  {
    label: "Product",
    value: "products"
  },
  {
    label: "Product Category",
    value: "product_categories"
  },
  {
    label: "Article",
    value: "articles"
  },
  {
    label: "Feature",
    value: "features"
  },
  {
    label: "Tag",
    value: "tags"
  },
  {
    label: "Category",
    value: "categories"
  },
  {
    label: "Product Orders",
    value: "product_orders"
  },
  {
    label: "Payment Gateways",
    value: "payment_gateways"
  },  
  {
    label: "Customer",
    value: "customers"
  },
  {
    label: "Customer Tier",
    value: "customer_tiers"
  },
  {
    label: "Currency",
    value: "currencies"
  },
  {
    label: "Contact",
    value: "contacts"
  },
  {
    label: "User",
    value: "users"
  },
  {
    label: "Delivery",
    value: "deliveries"
  },
  {
    label: "App Setting",
    value: "app_settings"
  },
  {
    label: "Push Notification",
    value: "push_notification"
  }
];



// WEBPACK FOOTER //
// ./src/pages/Company/constants.js